import React, { useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import COLORS from "../resources/colors/COLORS";
import SessionManager from "../Utils/SessionManager";
import {
  BrowserRouter as Router,
  Link,
  Redirect,
  Route,
  useParams,
  useHistory,
} from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import myToast from "../Utils/MyToast";
import Iframe from "react-iframe";
import SelectClass from "../ChildComponent/SelectClass";
import SelectAllClass from "../ChildComponent/SelectAllClass";
import BackButton from "../ChildComponent/BackButton";
import MdlSelectSession from "../dialog/MdlSelectSession";

const CollectionReport = () => {
  const { document_type } = useParams();
  const history = useHistory();
  
  // Helper function to format date as YYYY-MM-DD using local time (avoids timezone issues)
  // Memoized to avoid recreating on every render
  const formatDateLocal = useCallback((date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;

    
  }, []);
  
  const [loggedIn, setLoggedIn] = useState(!!localStorage.getItem("token"));
  const [Loading, setLoading] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [iFrameHeight, setIFrameHeight] = useState("0px");
  const [iframeLoading, setIframeLoading] = useState(false);
  const [FILE_URL, setFILE_URL] = useState("");
  const [FILE_NAME, setFILE_NAME] = useState("");
  const [FILE_DIRECTORY, setFILE_DIRECTORY] = useState("");
  const [DOCUMENT_TYPE, setDOCUMENT_TYPE] = useState("");
  const [SESSION_ID, setSESSION_ID] = useState("");
  const [CLASS_ID, setCLASS_ID] = useState("");
  const [SECTION_ID, setSECTION_ID] = useState("");
  const [SELECTED_CLASS_POSITION, setSELECTED_CLASS_POSITION] = useState(-1);
  const [mPrintableSamples, setMPrintableSamples] = useState([]);
  const [SELECTED_SAMPLE_ID, setSELECTED_SAMPLE_ID] = useState("");
  const [SELECTED_SAMPLE_POSITION, setSELECTED_SAMPLE_POSITION] = useState(0);
  const [CLASS_SECTION_NAME, setCLASS_SECTION_NAME] = useState("");
  const [mOptions, setMOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [mSessionList, setMSessionList] = useState([]);
  const [selectedSessionId, setSelectedSessionId] = useState("");
  const [selectedSessionName, setSelectedSessionName] = useState("");
  const [selectedSessionStatus, setSelectedSessionStatus] = useState("");
  const [isOpenSessionDialog, setIsOpenSessionDialog] = useState(false);
  const [mClassData, setMClassData] = useState([]);
  const [classBoard, setClassBoard] = useState([]);
  const [classMedium, setClassMedium] = useState([]);
  const [mFilteredClassSectionList, setMFilteredClassSectionList] = useState([]);
  const [selectedBoardId, setSelectedBoardId] = useState("");
  const [selectedMediumId, setSelectedMediumId] = useState("");
  const [filterClassList, setFilterClassList] = useState([]); // All classes for filter dropdown
  const [feeWiseSelectedMonth, setFeeWiseSelectedMonth] = useState("");
  const [feeWiseSelectAllMonths, setFeeWiseSelectAllMonths] = useState(false);
  const [feeWiseShowIndividualMonths, setFeeWiseShowIndividualMonths] = useState(false);
  const [reportType, setReportType] = useState("today");
  // Filter and Sort states
  const [filterClass, setFilterClass] = useState("");
  const [filterMonth, setFilterMonth] = useState("");
  const [filterSession, setFilterSession] = useState("");
  const [filterType, setFilterType] = useState("");
  const [filterMode, setFilterMode] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("ASC");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateRangePreset, setDateRangePreset] = useState("");
  const [showCalendar, setShowCalendar] = useState(true);
  const [calendarMonth, setCalendarMonth] = useState(new Date());
  const [selectingStartDate, setSelectingStartDate] = useState(true);
  const [sessionStartDate, setSessionStartDate] = useState("");
  const [sessionEndDate, setSessionEndDate] = useState("");

  //Created By Cursor
  const parseLooseDate = useCallback((raw) => {
    const value = String(raw || "").trim();
    if (!value) return null;
    if (/^\d{4}-\d{2}-\d{2}/.test(value)) {
      const d = new Date(value.slice(0, 10) + "T00:00:00");
      return Number.isNaN(d.getTime()) ? null : d;
    }
    const m = value.match(/^(\d{2})-(\d{2})-(\d{4})/);
    if (m) {
      const d = new Date(`${m[3]}-${m[2]}-${m[1]}T00:00:00`);
      return Number.isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }, []);

  //Created By Cursor
  const resolveAsOnDateBounds = useCallback(() => {
    const today = formatDateLocal(new Date());
    const start = parseLooseDate(sessionStartDate);
    return {
      from: start ? formatDateLocal(start) : today,
      to: today,
    };
  }, [formatDateLocal, parseLooseDate, sessionStartDate]);

  const handleDateRangePreset = (preset) => {
    const today = new Date();
    let newStartDate = "";
    let newEndDate = "";

    switch (preset) {
      case "today":
        newStartDate = newEndDate = formatDateLocal(today);
        break;
      case "yesterday":
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        newStartDate = newEndDate = formatDateLocal(yesterday);
        break;
      case "thisWeek":
        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - today.getDay());
        newStartDate = formatDateLocal(startOfWeek);
        newEndDate = formatDateLocal(today);
        break;
      case "lastWeek":
        const lastWeekEnd = new Date(today);
        lastWeekEnd.setDate(today.getDate() - today.getDay() - 1); // Last day of last week (Sunday)
        const lastWeekStart = new Date(lastWeekEnd);
        lastWeekStart.setDate(lastWeekEnd.getDate() - 6); // First day of last week (Monday)
        newStartDate = formatDateLocal(lastWeekStart);
        newEndDate = formatDateLocal(lastWeekEnd);
        break;
      case "last7Days":
        const last7Days = new Date(today);
        last7Days.setDate(today.getDate() - 7);
        newStartDate = formatDateLocal(last7Days);
        newEndDate = formatDateLocal(today);
        break;
      case "thisMonth":
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        newStartDate = formatDateLocal(startOfMonth);
        newEndDate = formatDateLocal(today);
        break;
      case "lastMonth":
        const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        newStartDate = formatDateLocal(firstDayLastMonth);
        newEndDate = formatDateLocal(lastDayLastMonth);
        break;
      case "last30Days":
        const last30Days = new Date(today);
        last30Days.setDate(today.getDate() - 30);
        newStartDate = formatDateLocal(last30Days);
        newEndDate = formatDateLocal(today);
        break;
      case "custom":
        // Keep existing dates, just mark as custom
        break;
      default:
        return;
    }

    setDateRangePreset(preset);
    setStartDate(newStartDate || startDate);
    setEndDate(newEndDate || endDate);
  };

  const handleCalendarDateClick = (date) => {
    const dateStr = formatDateLocal(date);
    
    if (selectingStartDate || !startDate || dateStr < startDate) {
      // Start new selection
      setStartDate(dateStr);
      setEndDate("");
      setSelectingStartDate(false);
      setDateRangePreset("custom");
    } else {
      // Complete the range
      setEndDate(dateStr);
      setSelectingStartDate(true);
      setDateRangePreset("custom");
    }
  };

  const navigateCalendarMonth = (direction) => {
    const newMonth = new Date(calendarMonth);
    newMonth.setMonth(newMonth.getMonth() + direction);
    setCalendarMonth(newMonth);
  };

  // Memoize calendar days generation to avoid recalculating on every render
  const generateCalendarDays = useMemo(() => {
    const year = calendarMonth.getFullYear();
    const month = calendarMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    
    const days = [];
    
    // Add all days of the month
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(new Date(year, month, day));
    }
    
    return days;
  }, [calendarMonth]);

  const isDateInRange = (date) => {
    if (!startDate || !endDate) return false;
    const dateStr = formatDateLocal(date);
    return dateStr >= startDate && dateStr <= endDate;
  };

  const isDateSelected = (date) => {
    const dateStr = formatDateLocal(date);
    return dateStr === startDate || dateStr === endDate;
  };

  const isToday = (date) => {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (document_type) {
      setDOCUMENT_TYPE(document_type);
      // Make API calls in parallel for better performance
      Promise.all([
        getPrintableSamples(document_type),
        fetchSessionList()
      ]).catch(error => {
        console.error("Error loading initial data:", error);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document_type]);

  const fetchSessionList = async () => {
    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getSessionList.php";
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`;

    try {
      const response = await axios.get(URL, {
        params: {
          school_code: SCHOOL_CODE,
        },
      });
      if (response.data.api_status === "OK") {
        const sessionList = response.data.data || [];
        setMSessionList(sessionList);
        
        // Auto-select current session if available
        if (sessionList.length > 0) {
          const currentDate = new Date();
          const currentYear = currentDate.getFullYear();
          
          // Find current session (active or current year)
          let selectedSession = sessionList.find(
            (session) =>
              session.status === "Active" ||
              session.session_name.includes(currentYear.toString())
          );

          // If no current session found, use first session
          if (!selectedSession) {
            selectedSession = sessionList[0];
          }

          handleSessionChange(selectedSession);
        }
      }
    } catch (error) {
      console.error("Error fetching session list:", error);
    }
  };

  // Fetch classes when session is available (for filter dropdown and classWise report)
  // This replaces the separate classWise fetch since classes are needed for filtering anyway
  useEffect(() => {
    const sessionIdToUse = selectedSessionId || SESSION_ID;
    if (sessionIdToUse) {
      // Always fetch classes when session is available (they're used for both filter and classWise)
      console.log("Loading classes for session:", sessionIdToUse);
      getClass(sessionIdToUse);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSessionId, SESSION_ID]);

  // Set "Today" as default when report type changes to dateRange
  useEffect(() => {
    if (reportType === "dateRange" && !dateRangePreset) {
      handleDateRangePreset("today");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportType]);

  // Auto-generate URL for "today" collection when all required fields are available
  useEffect(() => {
    if (
      reportType === "today" &&
      SESSION_ID &&
      SELECTED_SAMPLE_ID &&
      mPrintableSamples.length > 0
    ) {
      console.log("Auto-generating URL for today collection");
      setFileUrl();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportType, SESSION_ID, SELECTED_SAMPLE_ID, mPrintableSamples.length]);

  //Created By Cursor — Auto-generate URL for "As On Date" (session start → today)
  useEffect(() => {
    if (
      reportType === "asOnDate" &&
      SESSION_ID &&
      SELECTED_SAMPLE_ID &&
      mPrintableSamples.length > 0
    ) {
      const bounds = resolveAsOnDateBounds();
      if (bounds.from && bounds.to) {
        setStartDate(bounds.from);
        setEndDate(bounds.to);
        setFileUrl();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportType, SESSION_ID, SELECTED_SAMPLE_ID, mPrintableSamples.length, sessionStartDate]);

  // Auto-generate URL for "dateRange" when both dates are selected
  useEffect(() => {
    if (
      reportType === "dateRange" &&
      SESSION_ID &&
      SELECTED_SAMPLE_ID &&
      mPrintableSamples.length > 0 &&
      startDate &&
      endDate
    ) {
      console.log("Auto-generating URL for date range collection");
      setFileUrl();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportType, SESSION_ID, SELECTED_SAMPLE_ID, mPrintableSamples.length, startDate, endDate]);

  // Auto-generate URL for "feeWise" when month selection is made
  useEffect(() => {
    if (
      reportType === "feeWise" &&
      SESSION_ID &&
      SELECTED_SAMPLE_ID &&
      mPrintableSamples.length > 0 &&
      (feeWiseSelectAllMonths || feeWiseSelectedMonth)
    ) {
      console.log("Auto-generating URL for fee wise collection");
      setFileUrl();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportType, SESSION_ID, SELECTED_SAMPLE_ID, mPrintableSamples.length, feeWiseSelectAllMonths, feeWiseSelectedMonth, feeWiseShowIndividualMonths]);

  // Don't auto-load for month - user must explicitly select a month

  // Handle iframe height messages from the report
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.iframeHeight) {
        setIFrameHeight(`${event.data.iframeHeight}px`);
      }
    };
    window.addEventListener("message", handleMessage, false);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  // Call getClassList when board and medium are selected and class data is available
  useEffect(() => {
    if (selectedBoardId && selectedMediumId && mClassData.length > 0) {
      getClassList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBoardId, selectedMediumId, mClassData]);

  const handleSessionChange = (session) => {
    if (!session) return;
    
    setSESSION_ID(session.session_id);
    setSelectedSessionId(session.session_id);
    setSelectedSessionName(session.session_name);
    setSelectedSessionStatus(session.status || "");
    setSelectedOption(""); // Reset month selection
    setSessionStartDate(session.start_date || session.startDate || "");
    setSessionEndDate(session.end_date || session.endDate || "");

    // Clear class-related state when session changes
    setMClassData([]);
    setMFilteredClassSectionList([]);
    setClassBoard([]);
    setClassMedium([]);
    setSelectedBoardId("");
    setSelectedMediumId("");
    setCLASS_ID("");
    setSECTION_ID("");
    setCLASS_SECTION_NAME("");
    setSELECTED_CLASS_POSITION(-1);

    // Generate month options from session start to end date
    if (session.start_date && session.end_date) {
      const start_date = new Date(session.start_date);
      const end_date = new Date(session.end_date);
      const mYearMonth = [];
      while (start_date <= end_date) {
        const year = start_date.getFullYear();
        const month = String(start_date.getMonth() + 1).padStart(2, "0");
        mYearMonth.push(`${year}-${month}`);
        start_date.setMonth(start_date.getMonth() + 1);
      }
      setMOptions(mYearMonth);
      
      // Don't auto-select current month - let user choose
    }

    // Classes will be automatically fetched by the useEffect when selectedSessionId changes
  };

  const getClass = async (session_id) => {
    if (!session_id) return;
    
    try {
      setLoading(true);
      // Clear previous class data before fetching new data
      setMClassData([]);
      setMFilteredClassSectionList([]);
      setClassBoard([]);
      setClassMedium([]);
      setSelectedBoardId("");
      setSelectedMediumId("");
      
      const SCHOOL_CODE = SessionManager.getSchoolCode();
      const FUNCTION_NAME = "getClass.php";
      const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`;

      const response = await axios.get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          session_id: session_id,
        },
      });

      if (response.data.api_status === "OK") {
        const classData = response.data.data.class || [];
        const boardData = response.data.data.board || [];
        const mediumData = response.data.data.medium || [];
        
        setMClassData(classData);
        setClassBoard(boardData);
        setClassMedium(mediumData);

        // Auto-select first board and medium
        if (boardData.length > 0 && mediumData.length > 0) {
          setSelectedBoardId(boardData[0].board_id);
          setSelectedMediumId(mediumData[0].medium_id);
          // getClassList will be called by useEffect when selectedBoardId, selectedMediumId, and mClassData are set
        }
      } else {
        myToast.notify_warning(response.data.api_remark || "Failed to load classes");
      }
    } catch (error) {
      console.error("Error fetching class data:", error);
      myToast.notify_error("Failed to load classes");
    } finally {
      setLoading(false);
    }
  };

  const getClassList = () => {
    if (!selectedBoardId || !selectedMediumId) return;

    let filtered = [];
    let mFilteredClassList = [];

    // Filter classes by board and medium
    for (let item of mClassData) {
      if (item.board_id === selectedBoardId && item.medium_id === selectedMediumId) {
        mFilteredClassList.push(item);
      }
    }

    // Process sections
    for (let item of mFilteredClassList) {
      if (item.section === "No") {
        item["section_id"] = "No";
        filtered.push(item);
      } else {
        for (let section of item.section) {
          section["board_id"] = selectedBoardId;
          section["board_name"] = item.board_name;
          section["medium_id"] = selectedMediumId;
          section["medium_name"] = item.medium_name;
          filtered.push(section);
        }
      }
    }

    setMFilteredClassSectionList(filtered);
  };

  // Process all classes for filter dropdown (all boards and mediums)
  const processFilterClassList = () => {
    if (!mClassData || mClassData.length === 0) {
      setFilterClassList([]);
      return;
    }

    let allClasses = [];

    // Process all classes regardless of board/medium
    for (let item of mClassData) {
      if (item.section === "No" || !item.section) {
        // Class without sections
        allClasses.push({
          value: `${item.class_id}_No`,
          label: item.class_name || "",
          class_id: item.class_id,
          section_id: "No",
        });
      } else if (Array.isArray(item.section)) {
        // Class with sections
        for (let section of item.section) {
          const sectionId = section.section_id || "No";
          const sectionName = section.section_name || "";
          const className = item.class_name || "";
          allClasses.push({
            value: `${item.class_id}_${sectionId}`,
            label: sectionName ? `${className} - ${sectionName}` : className,
            class_id: item.class_id,
            section_id: sectionId,
          });
        }
      }
    }

    setFilterClassList(allClasses);
  };

  // Update filter class list when mClassData changes
  useEffect(() => {
    processFilterClassList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mClassData]);

  const handleSelectedSession = (session_id, session_name, session_status, start_date, end_date) => {
    const session = {
      session_id,
      session_name,
      status: session_status,
      start_date,
      end_date,
    };
    handleSessionChange(session);
    setIsOpenSessionDialog(false);
  };

  const getCurrentYearMonth = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  };

  const CallBackClassSelect = (
    class_id,
    section_id,
    session_id,
    selected_position,
    class_name,
    section_name,
    session_name,
    start_date,
    end_date
  ) => {
    setCLASS_ID(class_id);
    setSECTION_ID(section_id);
    setSESSION_ID(session_id);
    setCLASS_SECTION_NAME(section_id === "No" ? class_name : `${class_name}:${section_name}`);
    setSELECTED_CLASS_POSITION(selected_position);
    if (start_date) setSessionStartDate(start_date);
    if (end_date) setSessionEndDate(end_date);

    // Update month options based on selected session
    if (start_date && end_date) {
      const start = new Date(start_date);
      const end = new Date(end_date);
      const mYearMonth = [];
      while (start <= end) {
        const year = start.getFullYear();
        const month = String(start.getMonth() + 1).padStart(2, "0");
        mYearMonth.push(`${year}-${month}`);
        start.setMonth(start.getMonth() + 1);
      }
      setMOptions(mYearMonth);
    }
  };

  const getPrintableSamples = async (document_type) => {
    try {
      setLoading(true);
      const SCHOOL_CODE = SessionManager.getSchoolCode();
      const FUNCTION_NAME = "getPrintableSample.php";
      const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`;

      const response = await axios.get(URL, {
        params: {
          document_type: document_type,
          school_code: SCHOOL_CODE,
        },
      });

      if (response.data.api_status === "OK") {
        const samples = response.data.data || [];
        setMPrintableSamples(samples);
        setSELECTED_SAMPLE_ID(samples.length > 0 ? samples[0].sample_id : "");
        setSELECTED_SAMPLE_POSITION(0);
      } else {
        myToast.notify_warning(response.data.api_remark || "Failed to load samples");
      }
    } catch (error) {
      console.error("Error fetching printable samples:", error);
      myToast.notify_error("Failed to load printable samples");
    } finally {
      setLoading(false);
    }
  };

  const changeSample = (position) => {
    if (mPrintableSamples && mPrintableSamples[position]) {
      setSELECTED_SAMPLE_ID(mPrintableSamples[position].sample_id);
      setSELECTED_SAMPLE_POSITION(position);
    }
  };

  const setFileUrl = (overrideMonth = null, overrideClassId = null, overrideSectionId = null) => {
    // For "today", "dateRange", "month", and "feeWise" collections, CLASS_ID is optional
    // Use override values if provided, otherwise use state values
    const classIdToUse = overrideClassId !== null ? overrideClassId : CLASS_ID;
    const sectionIdToUse = overrideSectionId !== null ? overrideSectionId : SECTION_ID;
    
    if (reportType !== "today" && reportType !== "asOnDate" && reportType !== "dateRange" && reportType !== "month" && reportType !== "feeWise" && !classIdToUse) {
      myToast.notify_warning("Please select class");
      return;
    }
    if (!SESSION_ID) {
      myToast.notify_warning("Please ensure session is set");
      return;
    }

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const selectedSample = mPrintableSamples[SELECTED_SAMPLE_POSITION];
    
    if (!selectedSample) {
      myToast.notify_warning("Please select a sample");
      return;
    }

    const FILE_DIRECTORY = selectedSample.file_directory || "";
    const FILE_NAME = selectedSample.file_name || "";

    let FILE_URL = `${process.env.REACT_APP_SERVER_NAME}${FILE_DIRECTORY}${FILE_NAME}`;
    FILE_URL += `?session_id=${SESSION_ID}`;
    FILE_URL += `&sample_id=${SELECTED_SAMPLE_ID}`;
    FILE_URL += `&document_type=${DOCUMENT_TYPE}`;
    // Add class_id and section_id only if they exist (use override values if provided)
    if (classIdToUse) {
      FILE_URL += `&class_id=${classIdToUse}`;
      FILE_URL += `&section_id=${sectionIdToUse || ""}`;
    }
    
    // Add parameters based on report type
    if (reportType === "today") {
      const today = new Date();
      const todayStr = formatDateLocal(today);
      FILE_URL += `&report_type=today`;
      FILE_URL += `&date=${todayStr}`;
    } else if (reportType === "asOnDate") {
      const bounds = resolveAsOnDateBounds();
      if (!bounds.from || !bounds.to) {
        myToast.notify_warning("Session start date is missing");
        return;
      }
      FILE_URL += `&report_type=as_on_date`;
      FILE_URL += `&start_date=${bounds.from}`;
      FILE_URL += `&end_date=${bounds.to}`;
    } else if (reportType === "dateRange") {
      if (!startDate || !endDate) {
        myToast.notify_warning("Please select both start and end dates");
        return;
      }
      FILE_URL += `&report_type=date_range`;
      FILE_URL += `&start_date=${startDate}`;
      FILE_URL += `&end_date=${endDate}`;
    } else if (reportType === "classWise") {
      FILE_URL += `&report_type=class_wise`;
    } else if (reportType === "feeWise") {
      FILE_URL += `&report_type=fee_wise`;
      if (feeWiseSelectAllMonths) {
        FILE_URL += `&feeWiseSelectAllMonths=true`;
        if (feeWiseShowIndividualMonths) {
          FILE_URL += `&feeWiseShowIndividualMonths=true`;
        }
      } else if (feeWiseSelectedMonth) {
        FILE_URL += `&feeWiseSelectedMonth=${feeWiseSelectedMonth}`;
      }
    } else {
      FILE_URL += `&report_type=month`;
      // Use overrideMonth if provided, otherwise use selectedOption state
      const monthToUse = overrideMonth !== null ? overrideMonth : selectedOption;
      FILE_URL += `&year_month=${monthToUse || ""}`;
    }
    
    FILE_URL += `&school_code=${SCHOOL_CODE}`;
    FILE_URL += `&system_code=${process.env.REACT_APP_SYSTEM_CODE}`;
    
    // Add filter and sort parameters (only for non-feeWise reports)
    if (reportType !== "feeWise") {
      if (filterClass) FILE_URL += `&filter_class=${encodeURIComponent(filterClass)}`;
      if (filterMonth) FILE_URL += `&filter_month=${encodeURIComponent(filterMonth)}`;
      if (filterSession) FILE_URL += `&filter_session=${encodeURIComponent(filterSession)}`;
      if (filterType) FILE_URL += `&filter_type=${encodeURIComponent(filterType)}`;
      if (filterMode) FILE_URL += `&filter_mode=${encodeURIComponent(filterMode)}`;
      if (sortBy) FILE_URL += `&sort_by=${encodeURIComponent(sortBy)}`;
      if (sortOrder) FILE_URL += `&sort_order=${encodeURIComponent(sortOrder)}`;
    }

    console.log("Generated FILE_URL:", FILE_URL);
    setFILE_URL(FILE_URL);
    setFILE_NAME(FILE_NAME);
    setFILE_DIRECTORY(FILE_DIRECTORY);
    setShowPreview(true);
    setIFrameHeight("800px");
    setIframeLoading(true);
  };

  // Early returns
  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (Loading) {
    return <MyLoader />;
  }

  return (
      <div className="content" style={{ background: COLORS.whitesmoke, paddingLeft: "20px", paddingRight: "20px" }}>
        <div className="content-header">
          <div className="leftside-content-header">
            <ul className="breadcrumbs">
              <li>
                <i className="fa fa-home" aria-hidden="true" />
                <Link to="/AdminMain/ReportManagement">Report Management</Link>
                <span> / Collection Report</span>
              </li>
            </ul>
          </div>
          <div className="rightside-content-header">
            <BackButton onClick={() => history.goBack()} />
          </div>
        </div>

        <div
          className="animated fadeInUp bg_page_white_rounded box_shadow"
          style={{ marginTop: "20px", paddingLeft: "30px", paddingRight: "30px", paddingBottom: "30px" }}
        >
          <>
            {/* Session Selection & Report Type - Combined */}
              <div
                style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                  borderRadius: "16px",
                  padding: "0",
                  marginBottom: "20px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)",
                  border: "2px solid #e5e7eb",
                  overflow: "hidden",
                }}
              >
                {/* Session Selection */}
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsOpenSessionDialog(true);
                  }}
                  style={{ textDecoration: "none" }}
                >
                  <div
                    style={{
                      background: `linear-gradient(135deg, ${COLORS.primary_color_shade5 || "#3b82f6"} 0%, ${COLORS.primary_color_shade4 || "#2563eb"} 100%)`,
                      borderRadius: "0",
                      padding: "12px 20px",
                      marginBottom: "0",
                      boxShadow: "none",
                      border: "none",
                      cursor: "pointer",
                      transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                      borderBottom: "2px solid rgba(255, 255, 255, 0.1)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-1px) scale(1.005)";
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.18), 0 2px 6px rgba(0, 0, 0, 0.12)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0) scale(1)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <i
                          className="fa fa-calendar"
                          style={{
                            fontSize: "20px",
                            color: "#ffffff",
                            opacity: 0.9,
                          }}
                        ></i>
                        <div>
                          <p
                            style={{
                              margin: 0,
                              fontSize: "16px",
                              fontWeight: "700",
                              color: "#ffffff",
                              lineHeight: "1.4",
                            }}
                          >
                            {selectedSessionName || "Select Session"}
                          </p>
                          {selectedSessionStatus && (
                            <p
                              style={{
                                margin: "2px 0 0 0",
                                fontSize: "12px",
                                color: "rgba(255, 255, 255, 0.85)",
                                fontWeight: "500",
                              }}
                            >
                              Status: {selectedSessionStatus}
                            </p>
                          )}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "40px",
                          height: "40px",
                          borderRadius: "10px",
                          background: "rgba(255, 255, 255, 0.2)",
                          transition: "all 0.3s ease",
                        }}
                      >
                        <i
                          className="fa fa-chevron-right"
                          style={{
                            fontSize: "16px",
                            color: "#ffffff",
                            opacity: 0.9,
                          }}
                        ></i>
                      </div>
                    </div>
                  </div>
                </Link>

                {/* Report Type Selection */}
                <div
                  style={{
                    padding: "12px 16px",
                  }}
                >
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "10px" }}>
                  {[
                    { value: "today", label: "Today Collection", icon: "fa-calendar-day", color: "#10b981" },
                    { value: "asOnDate", label: "As On Date", icon: "fa-history", color: "#06b6d4" },
                    { value: "dateRange", label: "Date Range", icon: "fa-calendar-alt", color: "#3b82f6" },
                    { value: "month", label: "Month Wise", icon: "fa-calendar", color: "#8b5cf6" },
                    { value: "classWise", label: "Class Wise", icon: "fa-users", color: "#f59e0b" },
                    { value: "feeWise", label: "Fee Wise", icon: "fa-money-bill-wave", color: "#ef4444" },
                  ].map((option) => {
                    const isSelected = reportType === option.value;
                    return (
                      <div
                        key={option.value}
                        onClick={() => {
                          setReportType(option.value);
                          if (option.value === "asOnDate") {
                            const bounds = resolveAsOnDateBounds();
                            setStartDate(bounds.from);
                            setEndDate(bounds.to);
                            setDateRangePreset("");
                          }
                          // Clear iframe when switching to monthWise or classWise
                          if (option.value === "month" || option.value === "classWise") {
                            setFILE_URL("");
                            setShowPreview(false);
                            setIframeLoading(false);
                            // Clear month selection for monthWise
                            if (option.value === "month") {
                              setSelectedOption("");
                            }
                            // Clear class selection for classWise
                            if (option.value === "classWise") {
                              setCLASS_ID("");
                              setSECTION_ID("");
                              setSELECTED_CLASS_POSITION(-1);
                            }
                          }
                        }}
                        style={{
                          padding: "10px 12px",
                          borderRadius: "10px",
                          border: isSelected
                            ? `2px solid ${option.color}`
                            : "2px solid #e5e7eb",
                          background: isSelected
                            ? `linear-gradient(135deg, ${option.color}15 0%, ${option.color}08 100%)`
                            : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                          cursor: "pointer",
                          transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                          transform: isSelected ? "translateY(-2px)" : "translateY(0)",
                          boxShadow: isSelected
                            ? `0 4px 12px ${option.color}30, 0 2px 4px rgba(0, 0, 0, 0.1)`
                            : "0 2px 4px rgba(0, 0, 0, 0.05)",
                        }}
                        onMouseEnter={(e) => {
                          if (!isSelected) {
                            e.currentTarget.style.background = "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)";
                            e.currentTarget.style.borderColor = "#cbd5e1";
                            e.currentTarget.style.transform = "translateY(-1px)";
                            e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (!isSelected) {
                            e.currentTarget.style.background = "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)";
                            e.currentTarget.style.borderColor = "#e5e7eb";
                            e.currentTarget.style.transform = "translateY(0)";
                            e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <div
                            style={{
                              width: "32px",
                              height: "32px",
                              borderRadius: "8px",
                              background: isSelected
                                ? `linear-gradient(135deg, ${option.color} 0%, ${option.color}dd 100%)`
                                : `linear-gradient(135deg, ${option.color}20 0%, ${option.color}10 100%)`,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              transition: "all 0.3s ease",
                            }}
                          >
                            <i
                              className={`fa ${option.icon}`}
                              style={{
                                fontSize: "16px",
                                color: isSelected ? "#ffffff" : option.color,
                              }}
                            ></i>
                          </div>
                          <div style={{ flex: 1 }}>
                            <div
                              style={{
                                fontSize: "14px",
                                fontWeight: isSelected ? "700" : "600",
                                color: isSelected ? option.color : "#374151",
                              }}
                            >
                              {option.label}
                            </div>
                          </div>
                          {isSelected && (
                            <i
                              className="fa fa-check-circle"
                              style={{
                                fontSize: "18px",
                                color: option.color,
                              }}
                            ></i>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
                </div>
              </div>

              {/* Session Selection Modal */}
              {isOpenSessionDialog && (
                <MdlSelectSession
                  action={() => setIsOpenSessionDialog(false)}
                  action2={handleSelectedSession}
                />
              )}

              {/* Today Collection Section */}
              {reportType === "today" && (
                <div
                  style={{
                    background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                    borderRadius: "12px",
                    border: "2px solid #e5e7eb",
                    padding: "16px 20px",
                    marginBottom: "20px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.03)",
                  }}
                >
                  <h5 style={{ margin: 0, marginBottom: "12px", fontSize: "16px", fontWeight: "700", color: "#111827", display: "flex", alignItems: "center", gap: "8px" }}>
                    <i className="fa fa-calendar-day" style={{ color: "#10b981", fontSize: "16px" }}></i>
                    Today's Collection
                  </h5>
                  <div
                    style={{
                      padding: "12px",
                      background: "#ecfdf5",
                      borderRadius: "8px",
                      border: "1px solid #86efac",
                    }}
                  >
                    <i className="fa fa-info-circle me-2" style={{ color: "#10b981" }}></i>
                    <span style={{ color: "#047857", fontWeight: "600", fontSize: "14px" }}>
                      Report will be generated for today's collection: {new Date().toLocaleDateString()}
                    </span>
                  </div>
                </div>
              )}

              {/* As On Date Section */}
              {reportType === "asOnDate" && (
                <div
                  style={{
                    background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                    borderRadius: "12px",
                    border: "2px solid #e5e7eb",
                    padding: "16px 20px",
                    marginBottom: "20px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.03)",
                  }}
                >
                  <h5 style={{ margin: 0, marginBottom: "12px", fontSize: "16px", fontWeight: "700", color: "#111827", display: "flex", alignItems: "center", gap: "8px" }}>
                    <i className="fa fa-history" style={{ color: "#06b6d4", fontSize: "16px" }}></i>
                    As On Date
                  </h5>
                  <div
                    style={{
                      padding: "12px",
                      background: "#ecfeff",
                      borderRadius: "8px",
                      border: "1px solid #67e8f9",
                    }}
                  >
                    <i className="fa fa-info-circle me-2" style={{ color: "#06b6d4" }}></i>
                    <span style={{ color: "#0e7490", fontWeight: "600", fontSize: "14px" }}>
                      Report includes all collection from session start
                      {sessionStartDate
                        ? ` (${parseLooseDate(sessionStartDate)?.toLocaleDateString?.() || sessionStartDate})`
                        : ""}{" "}
                      to today ({new Date().toLocaleDateString()}).
                    </span>
                  </div>
                </div>
              )}

              {/* Date Range Section */}
              {reportType === "dateRange" && (
                <div
                  style={{
                    background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                    borderRadius: "12px",
                    border: "2px solid #e5e7eb",
                    padding: "12px 16px",
                    marginBottom: "20px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.03)",
                  }}
                >
                  <h5 style={{ margin: 0, marginBottom: "12px", fontSize: "16px", fontWeight: "700", color: "#111827", display: "flex", alignItems: "center", gap: "8px" }}>
                    <i className="fa fa-calendar-alt" style={{ color: "#3b82f6", fontSize: "16px" }}></i>
                    Date Range Selection
                  </h5>
                  
                  {/* Quick Date Range Buttons - Modern */}
                  <div style={{ marginBottom: "12px" }}>
                    <div style={{ 
                      display: "grid", 
                      gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))", 
                      gap: "8px" 
                    }}>
                      {[
                        { value: "today", label: "Today", icon: "fa-calendar-day", color: "#10b981" },
                        { value: "yesterday", label: "Yesterday", icon: "fa-calendar-minus", color: "#6366f1" },
                        { value: "thisWeek", label: "This Week", icon: "fa-calendar-week", color: "#3b82f6" },
                        { value: "lastWeek", label: "Last Week", icon: "fa-calendar-week", color: "#a855f7" },
                        { value: "last7Days", label: "Last 7 Days", icon: "fa-calendar", color: "#8b5cf6" },
                        { value: "thisMonth", label: "This Month", icon: "fa-calendar-alt", color: "#f59e0b" },
                        { value: "lastMonth", label: "Last Month", icon: "fa-calendar-check", color: "#ef4444" },
                        { value: "last30Days", label: "Last 30 Days", icon: "fa-calendar", color: "#06b6d4" },
                      ].map((preset) => {
                        const isSelected = dateRangePreset === preset.value;
                        return (
                          <button
                            key={preset.value}
                            type="button"
                            onClick={() => handleDateRangePreset(preset.value)}
                            style={{
                              padding: "10px 12px",
                              fontSize: "12px",
                              fontWeight: isSelected ? "700" : "600",
                              borderRadius: "10px",
                              border: isSelected
                                ? `2px solid ${preset.color}`
                                : "2px solid #e5e7eb",
                              background: isSelected
                                ? `linear-gradient(135deg, ${preset.color} 0%, ${preset.color}dd 100%)`
                                : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                              color: isSelected ? "#ffffff" : "#374151",
                              cursor: "pointer",
                              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "4px",
                              boxShadow: isSelected
                                ? `0 4px 12px ${preset.color}40, 0 2px 4px rgba(0, 0, 0, 0.1)`
                                : "0 2px 4px rgba(0, 0, 0, 0.05)",
                              transform: isSelected ? "translateY(-2px)" : "translateY(0)",
                              whiteSpace: "nowrap",
                            }}
                            onMouseEnter={(e) => {
                              if (!isSelected) {
                                e.currentTarget.style.background = `linear-gradient(135deg, ${preset.color}15 0%, ${preset.color}08 100%)`;
                                e.currentTarget.style.borderColor = preset.color;
                                e.currentTarget.style.transform = "translateY(-2px)";
                                e.currentTarget.style.boxShadow = `0 4px 12px ${preset.color}30, 0 2px 4px rgba(0, 0, 0, 0.1)`;
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!isSelected) {
                                e.currentTarget.style.background = "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)";
                                e.currentTarget.style.borderColor = "#e5e7eb";
                                e.currentTarget.style.transform = "translateY(0)";
                                e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                              }
                            }}
                          >
                            <div style={{
                              width: "24px",
                              height: "24px",
                              borderRadius: "6px",
                              background: isSelected
                                ? "rgba(255, 255, 255, 0.2)"
                                : `${preset.color}15`,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              transition: "all 0.3s ease",
                              flexShrink: 0,
                            }}>
                              <i 
                                className={`fa ${preset.icon}`} 
                                style={{ 
                                  fontSize: "12px",
                                  color: isSelected ? "#ffffff" : preset.color
                                }}
                              ></i>
                            </div>
                            <span style={{ flex: 1, textAlign: "left", whiteSpace: "nowrap" }}>{preset.label}</span>
                            {isSelected && (
                              <i 
                                className="fa fa-check-circle" 
                                style={{ 
                                  fontSize: "12px",
                                  color: "#ffffff",
                                  flexShrink: 0,
                                }}
                              ></i>
                            )}
                          </button>
                        );
                      })}
                    </div>
                  </div>

                  {/* Calendar View */}
                  <div>
                    {showCalendar && (
                      <div
                        style={{
                          background: "#ffffff",
                          borderRadius: "12px",
                          border: "2px solid #e5e7eb",
                          padding: "8px 10px",
                          marginBottom: "20px",
                          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                        }}
                      >
                        {/* Calendar Header - Compact */}
                        <div style={{ 
                          display: "flex", 
                          justifyContent: "space-between", 
                          alignItems: "center", 
                          marginBottom: "8px",
                          background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
                          padding: "8px 12px",
                          borderRadius: "10px",
                          border: "1px solid #bfdbfe"
                        }}>
                          <button
                            type="button"
                            onClick={() => navigateCalendarMonth(-1)}
                            style={{
                              padding: "4px 8px",
                              borderRadius: "6px",
                              border: "1px solid #93c5fd",
                              background: "#ffffff",
                              cursor: "pointer",
                              fontSize: "12px",
                              color: "#374151",
                              transition: "all 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = "#f3f4f6";
                              e.currentTarget.style.borderColor = "#60a5fa";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "#ffffff";
                              e.currentTarget.style.borderColor = "#93c5fd";
                            }}
                          >
                            <i className="fa fa-chevron-left"></i>
                          </button>
                          <h6 style={{ 
                            margin: 0, 
                            fontSize: "14px", 
                            fontWeight: "700", 
                            color: "#1e40af"
                          }}>
                            {calendarMonth.toLocaleString("default", { month: "short", year: "numeric" })}
                          </h6>
                          <button
                            type="button"
                            onClick={() => navigateCalendarMonth(1)}
                            style={{
                              padding: "4px 8px",
                              borderRadius: "6px",
                              border: "1px solid #93c5fd",
                              background: "#ffffff",
                              cursor: "pointer",
                              fontSize: "12px",
                              color: "#374151",
                              transition: "all 0.2s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = "#f3f4f6";
                              e.currentTarget.style.borderColor = "#60a5fa";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "#ffffff";
                              e.currentTarget.style.borderColor = "#93c5fd";
                            }}
                          >
                            <i className="fa fa-chevron-right"></i>
                          </button>
                        </div>

                        {/* Calendar - Single Row with 100% Width */}
                        <div style={{ width: "100%", overflowX: "hidden" }}>
                          <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                            {/* Weekday Headers - Single Row */}
                            <div style={{ 
                              display: "flex", 
                              gap: "1px", 
                              marginBottom: "3px", 
                              width: "100%"
                            }}>
                              {generateCalendarDays.map((date, index) => {
                                const dayIndex = date.getDay();
                                const dayNames = ["S", "M", "T", "W", "T", "F", "S"];
                                const totalDays = generateCalendarDays.length;
                                return (
                                  <div
                                    key={`header-${index}`}
                                    style={{
                                      textAlign: "center",
                                      fontSize: "12px",
                                      fontWeight: "600",
                                      color: "#475569",
                                      padding: "4px 1px",
                                      flex: "1",
                                      minWidth: 0,
                                      height: "24px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    {dayNames[dayIndex]}
                                  </div>
                                );
                              })}
                            </div>

                            {/* Calendar Days - Single Row */}
                            <div style={{ display: "flex", gap: "1px", width: "100%" }}>
                              {generateCalendarDays.map((date, index) => {
                                const dateStr = formatDateLocal(date);
                                const isInRange = isDateInRange(date);
                                const isSelected = isDateSelected(date);
                                const isTodayDate = isToday(date);
                                const isStartDate = dateStr === startDate;
                                const isEndDate = dateStr === endDate;
                                const isCurrentMonth = date.getMonth() === calendarMonth.getMonth();

                                return (
                                  <button
                                    key={dateStr}
                                    type="button"
                                    onClick={() => handleCalendarDateClick(date)}
                                    style={{
                                      padding: "4px 1px",
                                      fontSize: "12px",
                                      fontWeight: isSelected ? "700" : "500",
                                      borderRadius: "50%",
                                      border: isSelected
                                        ? "2px solid #3b82f6"
                                        : isInRange
                                        ? "1px solid #bfdbfe"
                                        : "1px solid transparent",
                                      background: isStartDate || isEndDate
                                        ? "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)"
                                        : isInRange
                                        ? "#eff6ff"
                                        : isTodayDate
                                        ? "#fef3c7"
                                        : !isCurrentMonth
                                        ? "#e5e7eb"
                                        : "#e2e8f0",
                                      color: isStartDate || isEndDate
                                        ? "#ffffff"
                                        : isTodayDate && !isInRange
                                        ? "#92400e"
                                        : !isCurrentMonth
                                        ? "#9ca3af"
                                        : "#374151",
                                      cursor: "pointer",
                                      transition: "all 0.2s ease",
                                      position: "relative",
                                      minHeight: "32px",
                                      flex: "1",
                                      minWidth: 0,
                                      aspectRatio: "1",
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                    onMouseEnter={(e) => {
                                      if (!isSelected && !isInRange && !isTodayDate) {
                                        e.currentTarget.style.background = "#f1f5f9";
                                        e.currentTarget.style.borderColor = "#cbd5e1";
                                      }
                                    }}
                                    onMouseLeave={(e) => {
                                      if (!isSelected && !isInRange && !isTodayDate) {
                                        e.currentTarget.style.background = !isCurrentMonth 
                                          ? "#e5e7eb" 
                                          : "#e2e8f0";
                                        e.currentTarget.style.borderColor = "transparent";
                                      }
                                    }}
                                    title={`${date.toLocaleDateString()}`}
                                  >
                                    <div style={{ fontSize: "13px", lineHeight: "1.3", fontWeight: "600" }}>{date.getDate()}</div>
                                    {date.getDate() === 1 && (
                                      <div style={{ fontSize: "9px", color: "#9ca3af", marginTop: "2px", fontWeight: "500" }}>
                                        {date.toLocaleString("default", { month: "short" }).substring(0, 3)}
                                      </div>
                                    )}
                                  </button>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Custom Date Range Inputs */}
                    <div style={{ marginTop: "20px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                        <div style={{ display: "flex", alignItems: "center", gap: "12px", flex: "1", minWidth: "200px" }}>
                          <label style={{ fontWeight: "600", fontSize: "14px", color: "#374151", margin: 0, whiteSpace: "nowrap" }}>
                            Start Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            value={startDate}
                            onChange={(e) => {
                              setStartDate(e.target.value);
                              setDateRangePreset("custom");
                            }}
                            style={{
                              padding: "10px 14px",
                              fontSize: "14px",
                              fontWeight: "600",
                              borderRadius: "10px",
                              border: "2px solid #e5e7eb",
                              cursor: "pointer",
                              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                              background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                              color: "#374151",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                              flex: 1,
                            }}
                            onFocus={(e) => {
                              e.target.style.borderColor = "#3b82f6";
                              e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 4px 12px rgba(59, 130, 246, 0.15)";
                              e.target.style.transform = "translateY(-2px)";
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = "#e5e7eb";
                              e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                              e.target.style.transform = "translateY(0)";
                            }}
                            onMouseEnter={(e) => {
                              if (document.activeElement !== e.target) {
                                e.target.style.borderColor = "#93c5fd";
                                e.target.style.boxShadow = "0 4px 8px rgba(59, 130, 246, 0.1)";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (document.activeElement !== e.target) {
                                e.target.style.borderColor = "#e5e7eb";
                                e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                              }
                            }}
                          />
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "12px", flex: "1", minWidth: "200px" }}>
                          <label style={{ fontWeight: "600", fontSize: "14px", color: "#374151", margin: 0, whiteSpace: "nowrap" }}>
                            End Date
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            value={endDate}
                            onChange={(e) => {
                              setEndDate(e.target.value);
                              setDateRangePreset("custom");
                            }}
                            min={startDate}
                            style={{
                              padding: "10px 14px",
                              fontSize: "14px",
                              fontWeight: "600",
                              borderRadius: "10px",
                              border: "2px solid #e5e7eb",
                              cursor: "pointer",
                              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                              background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                              color: "#374151",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                              flex: 1,
                            }}
                            onFocus={(e) => {
                              e.target.style.borderColor = "#3b82f6";
                              e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 4px 12px rgba(59, 130, 246, 0.15)";
                              e.target.style.transform = "translateY(-2px)";
                            }}
                            onBlur={(e) => {
                              e.target.style.borderColor = "#e5e7eb";
                              e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                              e.target.style.transform = "translateY(0)";
                            }}
                            onMouseEnter={(e) => {
                              if (document.activeElement !== e.target) {
                                e.target.style.borderColor = "#93c5fd";
                                e.target.style.boxShadow = "0 4px 8px rgba(59, 130, 246, 0.1)";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (document.activeElement !== e.target) {
                                e.target.style.borderColor = "#e5e7eb";
                                e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                              }
                            }}
                          />
                        </div>
                      </div>
                      {startDate && endDate && (
                        <div style={{ marginTop: "12px", padding: "10px", background: "#eff6ff", borderRadius: "8px", border: "1px solid #bfdbfe" }}>
                          <i className="fa fa-info-circle me-2" style={{ color: "#3b82f6" }}></i>
                          <span style={{ color: "#1e40af", fontWeight: "500", fontSize: "13px" }}>
                            Selected: {new Date(startDate).toLocaleDateString()} - {new Date(endDate).toLocaleDateString()}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* Month Wise Section */}
              {reportType === "month" && (
                <div
                  style={{
                    background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                    borderRadius: "12px",
                    border: "2px solid #e5e7eb",
                    padding: "16px 20px",
                    marginBottom: "20px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.03)",
                    overflow: "hidden",
                  }}
                >
                  {/* Month Selection */}
                  {mOptions.length > 0 && (
                    <div style={{ display: "flex", flexWrap: "nowrap", gap: "10px", overflowX: "auto", padding: "4px", margin: "-4px" }}>
                    {mOptions.map((option) => {
                      const isSelected = selectedOption === option;
                      // Format month display: Convert YYYY-MM to readable format
                      const date = new Date(option + "-01");
                      const monthName = date.toLocaleString("default", { month: "long" });
                      
                      return (
                        <label
                          key={option}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "8px",
                            padding: "8px 12px",
                            borderRadius: "10px",
                            background: isSelected
                              ? "linear-gradient(135deg, #8b5cf620 0%, #8b5cf610 100%)"
                              : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                            border: isSelected
                              ? "2px solid #8b5cf6"
                              : "2px solid #e5e7eb",
                            cursor: "pointer",
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            fontSize: "13px",
                            fontWeight: isSelected ? "700" : "600",
                            color: isSelected ? "#8b5cf6" : "#64748b",
                            boxShadow: isSelected
                              ? "0 4px 12px rgba(139, 92, 246, 0.25), 0 2px 4px rgba(0, 0, 0, 0.1)"
                              : "0 2px 4px rgba(0, 0, 0, 0.05)",
                            transform: isSelected ? "translateY(-2px)" : "translateY(0)",
                            minWidth: "80px",
                            flexShrink: 0,
                            boxSizing: "border-box",
                          }}
                          onMouseEnter={(e) => {
                            if (!isSelected) {
                              e.currentTarget.style.background = "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)";
                              e.currentTarget.style.borderColor = "#cbd5e1";
                              e.currentTarget.style.transform = "translateY(-1px)";
                              e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                            } else {
                              e.currentTarget.style.transform = "translateY(-3px)";
                              e.currentTarget.style.boxShadow = "0 6px 16px rgba(139, 92, 246, 0.3), 0 4px 8px rgba(0, 0, 0, 0.12)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isSelected) {
                              e.currentTarget.style.background = "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)";
                              e.currentTarget.style.borderColor = "#e5e7eb";
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                            } else {
                              e.currentTarget.style.transform = "translateY(-2px)";
                              e.currentTarget.style.boxShadow = "0 4px 12px rgba(139, 92, 246, 0.25), 0 2px 4px rgba(0, 0, 0, 0.1)";
                            }
                          }}
                        >
                          <input
                            type="radio"
                            name="monthSelection"
                            checked={isSelected}
                            onChange={() => {
                              setSelectedOption(option);
                              // Load report when user explicitly selects a month
                              // Pass the selected option directly to avoid stale state
                              if (SESSION_ID && SELECTED_SAMPLE_ID && mPrintableSamples.length > 0) {
                                setFileUrl(option);
                              }
                            }}
                            style={{
                              width: "16px",
                              height: "16px",
                              cursor: "pointer",
                              accentColor: "#8b5cf6",
                            }}
                          />
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", lineHeight: "1.3" }}>
                            <span>{monthName}</span>
                            <span style={{ fontSize: "11px", opacity: 0.8 }}>({option})</span>
                          </div>
                        </label>
                      );
                    })}
                    </div>
                  )}
                  {mOptions.length === 0 && selectedSessionId && (
                    <div style={{ padding: "12px", background: "#fef3c7", borderRadius: "8px", border: "1px solid #fbbf24" }}>
                      <i className="fa fa-info-circle me-2" style={{ color: "#f59e0b" }}></i>
                      <span style={{ color: "#92400e", fontWeight: "500", fontSize: "13px" }}>
                        No months available for the selected session. Please check session dates.
                      </span>
                    </div>
                  )}
                </div>
              )}

              {/* Class Wise Section */}
              {reportType === "classWise" && (
                <div
                  style={{
                    background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                    borderRadius: "12px",
                    border: "2px solid #e5e7eb",
                    padding: "12px 16px",
                    marginBottom: "20px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.03)",
                  }}
                >
                  <h5 style={{ margin: 0, marginBottom: "8px", fontSize: "14px", fontWeight: "700", color: "#111827", display: "flex", alignItems: "center", gap: "8px" }}>
                    <i className="fa fa-users" style={{ color: "#f59e0b", fontSize: "14px" }}></i>
                    Class Selection
                  </h5>
                  
                  {!selectedSessionId ? (
                    <div style={{ padding: "10px", background: "#fef3c7", borderRadius: "8px", border: "1px solid #fbbf24" }}>
                      <i className="fa fa-info-circle me-2" style={{ color: "#f59e0b" }}></i>
                      <span style={{ color: "#92400e", fontWeight: "500", fontSize: "13px" }}>
                        Please select a session first
                      </span>
                    </div>
                  ) : (
                    <>
                      {/* Board and Medium Selectors */}
                      <div style={{
                        background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                        borderRadius: "10px",
                        padding: "6px 12px",
                        marginBottom: "8px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04)",
                        border: "2px solid #e5e7eb",
                      }}>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "10px" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "700", color: "#111827", marginBottom: 0, display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }}>
                              <i className="fa fa-graduation-cap" style={{ color: COLORS.primary_color_shade5 || "#3b82f6", fontSize: "12px" }}></i>
                              Select Board:
                            </label>
                            <select
                              style={{
                                width: "100%",
                                padding: "6px 10px",
                                fontSize: "12px",
                                borderRadius: "8px",
                                border: "2px solid #e5e7eb",
                                background: "#ffffff",
                                fontWeight: "600",
                                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                outline: "none",
                                cursor: "pointer",
                                flex: 1,
                              }}
                              value={selectedBoardId}
                              onChange={(e) => {
                                const boardId = e.target.selectedOptions[0].getAttribute("board_id");
                                setSelectedBoardId(boardId);
                                getClassList();
                              }}
                            >
                              {classBoard.map((item, index) => (
                                <option key={index} board_id={item.board_id} value={item.board_id}>
                                  {item.board_name}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "700", color: "#111827", marginBottom: 0, display: "flex", alignItems: "center", gap: "6px", whiteSpace: "nowrap" }}>
                              <i className="fa fa-book" style={{ color: COLORS.primary_color_shade5 || "#3b82f6", fontSize: "12px" }}></i>
                              Select Medium:
                            </label>
                            <select
                              style={{
                                width: "100%",
                                padding: "6px 10px",
                                fontSize: "12px",
                                borderRadius: "8px",
                                border: "2px solid #e5e7eb",
                                background: "#ffffff",
                                fontWeight: "600",
                                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                outline: "none",
                                cursor: "pointer",
                                flex: 1,
                              }}
                              value={selectedMediumId}
                              onChange={(e) => {
                                const mediumId = e.target.selectedOptions[0].getAttribute("medium_id");
                                setSelectedMediumId(mediumId);
                                getClassList();
                              }}
                            >
                              {classMedium.map((item, index) => (
                                <option key={index} medium_id={item.medium_id} value={item.medium_id}>
                                  {item.medium_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      {/* Class/Section Cards */}
                      {mFilteredClassSectionList.length > 0 && (
                        <div style={{
                          background: "transparent",
                          borderRadius: "0",
                          padding: "4px 0",
                        }}>
                          <div style={{ display: "grid", gridTemplateColumns: "repeat(8, 1fr)", gap: "6px" }}>
                            {mFilteredClassSectionList.map((item, index) => {
                              const isSelected = SELECTED_CLASS_POSITION === index;
                              return (
                                <div
                                  key={index}
                                  style={{
                                    padding: "12px 12px",
                                    borderRadius: "10px",
                                    minHeight: "48px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    border: isSelected
                                      ? `2px solid ${COLORS.primary_color_shade5 || "#3b82f6"}`
                                      : "2px solid #e5e7eb",
                                    background: isSelected
                                      ? `linear-gradient(135deg, ${COLORS.primary_color_shade5 || "#3b82f6"}20 0%, ${COLORS.primary_color_shade5 || "#3b82f6"}10 100%)`
                                      : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                                    cursor: "pointer",
                                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                    textAlign: "center",
                                    boxShadow: isSelected
                                      ? `0 4px 12px ${(COLORS.primary_color_shade5 || "#3b82f6")}25, 0 2px 4px rgba(0, 0, 0, 0.1)`
                                      : "0 2px 4px rgba(0, 0, 0, 0.05)",
                                    transform: isSelected ? "translateY(-2px)" : "translateY(0)",
                                  }}
                                  onClick={() => {
                                    setSELECTED_CLASS_POSITION(index);
                                    CallBackClassSelect(
                                      item.class_id,
                                      item.section_id,
selectedSessionId,
                                      index,
                                      item.class_name,
                                      item.section_name || "",
selectedSessionName,
                                      "",
                                      ""
                                    );
                                    // Load report when user explicitly selects a class
                                    // Pass class_id and section_id directly to avoid stale state
                                    if (SESSION_ID && SELECTED_SAMPLE_ID && mPrintableSamples.length > 0) {
                                      setFileUrl(null, item.class_id, item.section_id);
                                    }
                                  }}
                                  onMouseEnter={(e) => {
                                    if (!isSelected) {
                                      e.currentTarget.style.background = "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)";
                                      e.currentTarget.style.borderColor = "#cbd5e1";
                                      e.currentTarget.style.transform = "translateY(-2px)";
                                      e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    if (!isSelected) {
                                      e.currentTarget.style.background = "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)";
                                      e.currentTarget.style.borderColor = "#e5e7eb";
                                      e.currentTarget.style.transform = "translateY(0)";
                                      e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                                    }
                                  }}
                                >
                                  <p style={{
                                    fontSize: "12px",
                                    fontWeight: isSelected ? "700" : "600",
                                    color: isSelected ? (COLORS.primary_color_shade5 || "#3b82f6") : "#111827",
                                    margin: 0,
                                  }}>
                                    {item.section_id === "No"
                                      ? item.class_name
                                      : `${item.class_name}: ${item.section_name}`}
                                  </p>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}

              {/* Fee Wise Section */}
              {reportType === "feeWise" && (
                <div
                  style={{
                    background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                    borderRadius: "12px",
                    border: "2px solid #e5e7eb",
                    padding: "12px 16px",
                    marginBottom: "20px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.03)",
                  }}
                >
                  {!selectedSessionId ? (
                    <div style={{ padding: "10px", background: "#fef3c7", borderRadius: "8px", border: "1px solid #fbbf24" }}>
                      <i className="fa fa-info-circle me-2" style={{ color: "#f59e0b" }}></i>
                      <span style={{ color: "#92400e", fontWeight: "500", fontSize: "13px" }}>
                        Please select a session first
                      </span>
                    </div>
                  ) : (
                    <>
                      {/* Month Selection */}
                      {mOptions.length > 0 && (
                        <div style={{ marginBottom: "10px" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                            <label style={{ fontSize: "12px", fontWeight: "700", color: "#111827", margin: 0, display: "flex", alignItems: "center", gap: "6px" }}>
                              <i className="fa fa-calendar me-2" style={{ color: "#ef4444" }}></i>
                              Select Month
                            </label>
                            {feeWiseSelectAllMonths && (
                              <label style={{ 
                                display: "flex", 
                                alignItems: "center", 
                                gap: "4px", 
                                cursor: "pointer",
                                fontSize: "12px",
                                fontWeight: "600",
                                color: "#ef4444",
                                padding: "4px 8px",
                                borderRadius: "6px",
                                background: feeWiseShowIndividualMonths ? "linear-gradient(135deg, #ef444420 0%, #ef444410 100%)" : "transparent",
                                border: feeWiseShowIndividualMonths ? "1px solid #ef4444" : "1px solid transparent",
                                transition: "all 0.2s ease"
                              }}>
                                <input
                                  type="checkbox"
                                  checked={feeWiseShowIndividualMonths}
                                  onChange={(e) => {
                                    setFeeWiseShowIndividualMonths(e.target.checked);
                                  }}
                                  style={{
                                    width: "16px",
                                    height: "16px",
                                    cursor: "pointer",
                                    accentColor: "#ef4444",
                                  }}
                                />
                                <span>Show Individual Months</span>
                              </label>
                            )}
                          </div>
                          <div style={{ display: "flex", flexWrap: "nowrap", gap: "6px", overflowX: "hidden", padding: "2px", margin: "-2px", width: "100%" }}>
                            {/* All Months Option */}
                            <label
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "4px",
                                padding: "6px 10px",
                                borderRadius: "10px",
                                background: feeWiseSelectAllMonths
                                  ? "linear-gradient(135deg, #ef444420 0%, #ef444410 100%)"
                                  : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                                border: feeWiseSelectAllMonths
                                  ? "2px solid #ef4444"
                                  : "2px solid #e5e7eb",
                                cursor: "pointer",
                                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                fontSize: "12px",
                                fontWeight: feeWiseSelectAllMonths ? "700" : "600",
                                color: feeWiseSelectAllMonths ? "#ef4444" : "#64748b",
                                boxShadow: feeWiseSelectAllMonths
                                  ? "0 4px 12px rgba(239, 68, 68, 0.25), 0 2px 4px rgba(0, 0, 0, 0.1)"
                                  : "0 2px 4px rgba(0, 0, 0, 0.05)",
                                transform: feeWiseSelectAllMonths ? "translateY(-2px)" : "translateY(0)",
                                minWidth: "70px",
                                flex: "1",
                                flexShrink: 0,
                                boxSizing: "border-box",
                                maxWidth: "100%",
                              }}
                              onMouseEnter={(e) => {
                                if (!feeWiseSelectAllMonths) {
                                  e.currentTarget.style.background = "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)";
                                  e.currentTarget.style.borderColor = "#cbd5e1";
                                  e.currentTarget.style.transform = "translateY(-1px)";
                                  e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (!feeWiseSelectAllMonths) {
                                  e.currentTarget.style.background = "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)";
                                  e.currentTarget.style.borderColor = "#e5e7eb";
                                  e.currentTarget.style.transform = "translateY(0)";
                                  e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                                }
                              }}
                            >
                              <input
                                type="radio"
                                name="feeWiseMonthSelection"
                                checked={feeWiseSelectAllMonths}
                                onChange={() => {
                                  setFeeWiseSelectAllMonths(true);
                                  setFeeWiseSelectedMonth("");
                                }}
                                style={{
                                  width: "16px",
                                  height: "16px",
                                  cursor: "pointer",
                                  accentColor: "#ef4444",
                                }}
                              />
                              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", lineHeight: "1.3" }}>
                                <span>All Months</span>
                                <span style={{ fontSize: "11px", opacity: 0.8 }}>({mOptions.length})</span>
                              </div>
                            </label>
                            
                            {mOptions.map((option) => {
                              const isSelected = !feeWiseSelectAllMonths && feeWiseSelectedMonth === option;
                              const date = new Date(option + "-01");
                              const monthName = date.toLocaleString("default", { month: "long" });
                              
                              return (
                                <label
                                  key={option}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: "4px",
                                    padding: "6px 10px",
                                    borderRadius: "10px",
                                    background: isSelected
                                      ? "linear-gradient(135deg, #ef444420 0%, #ef444410 100%)"
                                      : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                                    border: isSelected
                                      ? "2px solid #ef4444"
                                      : "2px solid #e5e7eb",
                                    cursor: "pointer",
                                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                    fontSize: "12px",
                                    fontWeight: isSelected ? "700" : "600",
                                    color: isSelected ? "#ef4444" : "#64748b",
                                    boxShadow: isSelected
                                      ? "0 4px 12px rgba(239, 68, 68, 0.25), 0 2px 4px rgba(0, 0, 0, 0.1)"
                                      : "0 2px 4px rgba(0, 0, 0, 0.05)",
                                    transform: isSelected ? "translateY(-2px)" : "translateY(0)",
                                    minWidth: "70px",
                                    flexShrink: 0,
                                    boxSizing: "border-box",
                                  }}
                                  onMouseEnter={(e) => {
                                    if (!isSelected) {
                                      e.currentTarget.style.background = "linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%)";
                                      e.currentTarget.style.borderColor = "#cbd5e1";
                                      e.currentTarget.style.transform = "translateY(-1px)";
                                      e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    if (!isSelected) {
                                      e.currentTarget.style.background = "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)";
                                      e.currentTarget.style.borderColor = "#e5e7eb";
                                      e.currentTarget.style.transform = "translateY(0)";
                                      e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                                    }
                                  }}
                                >
                                  <input
                                    type="radio"
                                    name="feeWiseMonthSelection"
                                    checked={isSelected}
                                    onChange={() => {
                                      setFeeWiseSelectedMonth(option);
                                      setFeeWiseSelectAllMonths(false);
                                    }}
                                    style={{
                                      width: "16px",
                                      height: "16px",
                                      cursor: "pointer",
                                      accentColor: "#ef4444",
                                    }}
                                  />
                                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", lineHeight: "1.3" }}>
                                    <span>{monthName}</span>
                                    <span style={{ fontSize: "11px", opacity: 0.8 }}>({option})</span>
                                  </div>
                                </label>
                              );
                            })}
                          </div>
                        </div>
                      )}
                      
                      {mOptions.length === 0 && (
                        <div style={{ padding: "10px", background: "#fef3c7", borderRadius: "8px", border: "1px solid #fbbf24" }}>
                          <i className="fa fa-info-circle me-2" style={{ color: "#f59e0b" }}></i>
                          <span style={{ color: "#92400e", fontWeight: "500", fontSize: "13px" }}>
                            No months available for the selected session. Please check session dates.
                          </span>
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}

              {/* Filter and Sort Section - Only for non-feeWise reports */}
              {reportType !== "feeWise" && mPrintableSamples.length > 0 && SESSION_ID && (
                <div style={{
                  width: "100%",
                  background: "linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%)",
                  backdropFilter: "blur(10px)",
                  borderRadius: "12px",
                  border: "1px solid rgba(226, 232, 240, 0.8)",
                  padding: "12px",
                  marginBottom: "12px",
                  boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.05)",
                  transition: "all 0.3s ease",
                  boxSizing: "border-box",
                }}>
                  <h5 style={{ 
                    margin: "0 0 10px 0", 
                    fontSize: "16px", 
                    fontWeight: "700", 
                    color: "#1e293b", 
                    display: "flex", 
                    alignItems: "center", 
                    gap: "8px",
                    letterSpacing: "-0.01em",
                  }}>
                    <i className="fa fa-filter" style={{ 
                      color: "#3b82f6", 
                      fontSize: "16px",
                      filter: "drop-shadow(0 1px 2px rgba(59, 130, 246, 0.3))",
                    }}></i>
                    Filter & Sort
                  </h5>
                  
                  <div style={{ 
                    width: "100%",
                    display: "flex", 
                    flexWrap: "nowrap", 
                    gap: "8px", 
                    alignItems: "end",
                    overflowX: "auto",
                    overflowY: "hidden",
                    boxSizing: "border-box",
                  }}>
                    {/* Filter by Class */}
                    <div style={{ flex: "1 1 auto", minWidth: "110px", maxWidth: "140px" }}>
                      <label style={{ 
                        display: "block", 
                        fontSize: "11px", 
                        fontWeight: "600", 
                        color: "#475569", 
                        marginBottom: "4px",
                        letterSpacing: "0.01em",
                      }}>
                        Filter by Class
                      </label>
                      <select
                        value={filterClass}
                        onChange={(e) => setFilterClass(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          fontSize: "12px",
                          border: "1.5px solid #e2e8f0",
                          borderRadius: "8px",
                          background: "#ffffff",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          outline: "none",
                          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#3b82f6";
                          e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#e2e8f0";
                          e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onMouseEnter={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#cbd5e1";
                            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#e2e8f0";
                            e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        <option value="">All Classes</option>
                        {filterClassList.map((classItem, index) => (
                          <option key={index} value={classItem.value}>
                            {classItem.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    
                    {/* Filter by Month */}
                    <div style={{ flex: "1 1 auto", minWidth: "110px", maxWidth: "140px" }}>
                      <label style={{ 
                        display: "block", 
                        fontSize: "11px", 
                        fontWeight: "600", 
                        color: "#475569", 
                        marginBottom: "4px",
                        letterSpacing: "0.01em",
                      }}>
                        Filter by Month
                      </label>
                      <select
                        value={filterMonth}
                        onChange={(e) => setFilterMonth(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          fontSize: "12px",
                          border: "1.5px solid #e2e8f0",
                          borderRadius: "8px",
                          background: "#ffffff",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          outline: "none",
                          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#3b82f6";
                          e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#e2e8f0";
                          e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onMouseEnter={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#cbd5e1";
                            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#e2e8f0";
                            e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        <option value="">All Months</option>
                        {mOptions.map((option) => {
                          const date = new Date(option + "-01");
                          const monthLabel = date.toLocaleString("default", { month: "long", year: "numeric" });
                          return (
                            <option key={option} value={option}>
                              {monthLabel}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    
                    {/* Filter by Session */}
                    <div style={{ flex: "1 1 auto", minWidth: "110px", maxWidth: "140px" }}>
                      <label style={{ 
                        display: "block", 
                        fontSize: "11px", 
                        fontWeight: "600", 
                        color: "#475569", 
                        marginBottom: "4px",
                        letterSpacing: "0.01em",
                      }}>
                        Filter by Session
                      </label>
                      <select
                        value={filterSession}
                        onChange={(e) => setFilterSession(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          fontSize: "12px",
                          border: "1.5px solid #e2e8f0",
                          borderRadius: "8px",
                          background: "#ffffff",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          outline: "none",
                          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#3b82f6";
                          e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#e2e8f0";
                          e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onMouseEnter={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#cbd5e1";
                            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#e2e8f0";
                            e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        <option value="">All Sessions</option>
                        {mSessionList.map((session) => (
                          <option key={session.session_id} value={session.session_id}>
                            {session.session_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    
                    {/* Filter by Type */}
                    <div style={{ flex: "1 1 auto", minWidth: "110px", maxWidth: "140px" }}>
                      <label style={{ 
                        display: "block", 
                        fontSize: "11px", 
                        fontWeight: "600", 
                        color: "#475569", 
                        marginBottom: "4px",
                        letterSpacing: "0.01em",
                      }}>
                        Filter by Type
                      </label>
                      <select
                        value={filterType}
                        onChange={(e) => setFilterType(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          fontSize: "12px",
                          border: "1.5px solid #e2e8f0",
                          borderRadius: "8px",
                          background: "#ffffff",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          outline: "none",
                          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#3b82f6";
                          e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#e2e8f0";
                          e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onMouseEnter={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#cbd5e1";
                            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#e2e8f0";
                            e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        <option value="">All Types</option>
                        <option value="FEE">FEE</option>
                        <option value="OLD_DUE">OLD_DUE</option>
                        <option value="ACCESSORIES">ACCESSORIES</option>
                      </select>
                    </div>
                    
                    {/* Filter by Mode */}
                    <div style={{ flex: "1 1 auto", minWidth: "110px", maxWidth: "140px" }}>
                      <label style={{ 
                        display: "block", 
                        fontSize: "11px", 
                        fontWeight: "600", 
                        color: "#475569", 
                        marginBottom: "4px",
                        letterSpacing: "0.01em",
                      }}>
                        Filter by Mode
                      </label>
                      <select
                        value={filterMode}
                        onChange={(e) => setFilterMode(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          fontSize: "12px",
                          border: "1.5px solid #e2e8f0",
                          borderRadius: "8px",
                          background: "#ffffff",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          outline: "none",
                          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#3b82f6";
                          e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#e2e8f0";
                          e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onMouseEnter={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#cbd5e1";
                            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#e2e8f0";
                            e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        <option value="">All Modes</option>
                        <option value="CASH">CASH</option>
                        <option value="CHEQUE">CHEQUE</option>
                        <option value="ONLINE">ONLINE</option>
                        <option value="UPI">UPI</option>
                      </select>
                    </div>
                    
                    {/* Sort By */}
                    <div style={{ flex: "1 1 auto", minWidth: "110px", maxWidth: "140px" }}>
                      <label style={{ 
                        display: "block", 
                        fontSize: "11px", 
                        fontWeight: "600", 
                        color: "#475569", 
                        marginBottom: "4px",
                        letterSpacing: "0.01em",
                      }}>
                        Sort By
                      </label>
                      <select
                        value={sortBy}
                        onChange={(e) => setSortBy(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          fontSize: "12px",
                          border: "1.5px solid #e2e8f0",
                          borderRadius: "8px",
                          background: "#ffffff",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          outline: "none",
                          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#3b82f6";
                          e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#e2e8f0";
                          e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onMouseEnter={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#cbd5e1";
                            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#e2e8f0";
                            e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        <option value="">Default</option>
                        <option value="student_name">Student Name</option>
                        <option value="roll_no">Roll No</option>
                        <option value="transaction_date">Transaction Date</option>
                        <option value="amount_paid">Amount Paid</option>
                      </select>
                    </div>
                    
                    {/* Sort Order */}
                    <div style={{ flex: "1 1 auto", minWidth: "100px", maxWidth: "120px" }}>
                      <label style={{ 
                        display: "block", 
                        fontSize: "11px", 
                        fontWeight: "600", 
                        color: "#475569", 
                        marginBottom: "4px",
                        letterSpacing: "0.01em",
                      }}>
                        Order
                      </label>
                      <select
                        value={sortOrder}
                        onChange={(e) => setSortOrder(e.target.value)}
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          fontSize: "12px",
                          border: "1.5px solid #e2e8f0",
                          borderRadius: "8px",
                          background: "#ffffff",
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          outline: "none",
                          boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                        }}
                        onFocus={(e) => {
                          e.target.style.borderColor = "#3b82f6";
                          e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = "#e2e8f0";
                          e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                        }}
                        onMouseEnter={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#cbd5e1";
                            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.08)";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (document.activeElement !== e.target) {
                            e.target.style.borderColor = "#e2e8f0";
                            e.target.style.boxShadow = "0 1px 2px rgba(0, 0, 0, 0.05)";
                          }
                        }}
                      >
                        <option value="ASC">Ascending</option>
                        <option value="DESC">Descending</option>
                      </select>
                    </div>
                    
                    {/* Action Buttons */}
                    <div style={{ 
                      display: "flex", 
                      gap: "6px", 
                      flex: "0 0 auto", 
                      flexWrap: "nowrap",
                      alignItems: "end",
                      whiteSpace: "nowrap",
                    }}>
                      <button
                        type="button"
                        onClick={() => {
                          // Reload the report with current filter/sort values
                          setFileUrl();
                        }}
                        style={{
                          padding: "6px 12px",
                          fontSize: "12px",
                          fontWeight: "600",
                          background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                          color: "#ffffff",
                          border: "none",
                          borderRadius: "8px",
                          cursor: "pointer",
                          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                          boxShadow: "0 2px 4px rgba(59, 130, 246, 0.2), 0 1px 2px rgba(0, 0, 0, 0.1)",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          flexShrink: 0,
                          whiteSpace: "nowrap",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-1px)";
                          e.currentTarget.style.boxShadow = "0 4px 8px rgba(59, 130, 246, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(59, 130, 246, 0.2), 0 1px 2px rgba(0, 0, 0, 0.1)";
                        }}
                        onMouseDown={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                        }}
                        onMouseUp={(e) => {
                          e.currentTarget.style.transform = "translateY(-1px)";
                        }}
                      >
                        <i className="fa fa-filter"></i> Apply
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          setFilterClass("");
                          setFilterMonth("");
                          setFilterSession("");
                          setFilterType("");
                          setFilterMode("");
                          setSortBy("");
                          setSortOrder("ASC");
                          // Reload the report after clearing filters
                          setTimeout(() => {
                            setFileUrl();
                          }, 100);
                        }}
                        style={{
                          padding: "6px 12px",
                          fontSize: "12px",
                          fontWeight: "600",
                          background: "linear-gradient(135deg, #64748b 0%, #475569 100%)",
                          color: "#ffffff",
                          border: "none",
                          borderRadius: "8px",
                          cursor: "pointer",
                          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                          boxShadow: "0 2px 4px rgba(100, 116, 139, 0.2), 0 1px 2px rgba(0, 0, 0, 0.1)",
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          flexShrink: 0,
                          whiteSpace: "nowrap",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "translateY(-1px)";
                          e.currentTarget.style.boxShadow = "0 4px 8px rgba(100, 116, 139, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(100, 116, 139, 0.2), 0 1px 2px rgba(0, 0, 0, 0.1)";
                        }}
                        onMouseDown={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                        }}
                        onMouseUp={(e) => {
                          e.currentTarget.style.transform = "translateY(-1px)";
                        }}
                      >
                        <i className="fa fa-times"></i> Clear
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {mPrintableSamples.length > 1 && (
                <div className="row" style={{ marginTop: 0, marginBottom: 0 }}>
                  <div className="col-sm-12" style={{ paddingTop: 0, paddingBottom: 0 }}>
                    <h5 style={{ margin: 0, padding: 0, display: "flex", alignItems: "center", gap: "8px" }}>
                      <i className="fa fa-file-alt" style={{ fontSize: "16px" }}></i>
                      Select Sample
                    </h5>
                    <div className="row">
                      {mPrintableSamples.map((sample, index) => (
                        <div key={sample.sample_id} className="col-sm-3 col-md-3" style={{ padding: "8px" }}>
                          <div
                            className={`bg_corner_round_grey ${SELECTED_SAMPLE_POSITION === index ? "border-primary" : ""}`}
                            style={{
                              padding: "10px 12px",
                              cursor: "pointer",
                              border: SELECTED_SAMPLE_POSITION === index ? "2px solid " + COLORS.primary_color_shade5 : "1px solid #e0e0e0",
                              transition: "all 0.3s ease",
                              display: "flex",
                              alignItems: "center",
                              gap: "10px",
                              minHeight: "auto",
                            }}
                            onClick={() => changeSample(index)}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "translateY(-2px)";
                              e.currentTarget.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow = "none";
                            }}
                          >
                            <i className="fa fa-file-pdf" style={{ fontSize: "24px", color: COLORS.primary_color_shade5, flexShrink: 0 }}></i>
                            <p style={{ margin: 0, fontWeight: "600", fontSize: "14px", flex: 1 }}>
                              {sample.sample_name || "Sample " + (index + 1)}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

            {/* Show iframe below the form when URL is available */}
            {FILE_URL && (
              <div style={{
                marginTop: "20px",
                marginLeft: "0",
                marginRight: "0",
                width: "100%",
                boxSizing: "border-box",
              }}>
                <div style={{ 
                  position: "relative", 
                  width: "100%", 
                  minHeight: iFrameHeight,
                  backgroundColor: "transparent",
                  border: "none",
                  borderRadius: "0",
                  overflow: "hidden",
                  boxShadow: "none",
                  isolation: "isolate",
                  margin: "0",
                  padding: "0",
                  boxSizing: "border-box",
                }}>
                {/* Modern Loading Overlay */}
                {iframeLoading && (
                  <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    backdropFilter: "blur(4px)",
                    zIndex: 20,
                    borderRadius: "8px",
                  }}>
                    {/* Animated Progress Bar */}
                    <div style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "3px",
                      backgroundColor: "#e5e7eb",
                      overflow: "hidden",
                    }}>
                      <div style={{
                        height: "100%",
                        width: "30%",
                        background: "linear-gradient(90deg, transparent, #3b82f6, transparent)",
                        animation: "shimmer 1.5s ease-in-out infinite",
                      }} />
                    </div>
                    
                    {/* Modern Spinner */}
                    <div style={{
                      width: "60px",
                      height: "60px",
                      position: "relative",
                      marginBottom: "20px",
                    }}>
                      <div style={{
                        width: "100%",
                        height: "100%",
                        border: "4px solid #e5e7eb",
                        borderTop: "4px solid #3b82f6",
                        borderRadius: "50%",
                        animation: "spin 0.8s linear infinite",
                      }} />
                      <div style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "40px",
                        height: "40px",
                        border: "3px solid #e5e7eb",
                        borderRight: "3px solid #2563eb",
                        borderRadius: "50%",
                        animation: "spin 0.6s linear infinite reverse",
                      }} />
                    </div>
                    
                    {/* Loading Text */}
                    <div style={{
                      fontSize: "16px",
                      fontWeight: "600",
                      color: "#1e40af",
                      marginBottom: "8px",
                      letterSpacing: "0.5px",
                    }}>
                      Loading Report...
                    </div>
                    
                    {/* Animated Dots */}
                    <div style={{
                      display: "flex",
                      gap: "6px",
                      alignItems: "center",
                    }}>
                      <div style={{
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        backgroundColor: "#3b82f6",
                        animation: "bounce 1.4s ease-in-out infinite",
                        animationDelay: "0s",
                      }} />
                      <div style={{
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        backgroundColor: "#3b82f6",
                        animation: "bounce 1.4s ease-in-out infinite",
                        animationDelay: "0.2s",
                      }} />
                      <div style={{
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        backgroundColor: "#3b82f6",
                        animation: "bounce 1.4s ease-in-out infinite",
                        animationDelay: "0.4s",
                      }} />
                    </div>
                    
                    {/* Loading Message */}
                    <div style={{
                      fontSize: "13px",
                      color: "#64748b",
                      marginTop: "16px",
                      textAlign: "center",
                      maxWidth: "300px",
                      lineHeight: "1.5",
                    }}>
                      {FILE_URL ? "Please wait while the report is being generated" : "Preparing report..."}
                    </div>
                  </div>
                )}
                
                <Iframe
                  src={FILE_URL}
                  width="100%"
                  height={iFrameHeight}
                  id="reportFrame"
                  className="preview-iframe"
                  display="block"
                  position="relative"
                  style={{ 
                    border: "none", 
                    backgroundColor: "transparent",
                    minHeight: "600px",
                    display: "block",
                    zIndex: 1,
                    opacity: iframeLoading ? 0 : 1,
                    transition: "opacity 0.3s ease-in-out",
                  }}
                  frameBorder="0"
                  scrolling="no"
                  allowFullScreen
                  onLoad={() => {
                    console.log("Iframe loaded successfully");
                    console.log("Iframe URL:", FILE_URL);
                    setIframeLoading(false);
                  }}
                  onError={() => {
                    console.error("Iframe failed to load");
                    setIframeLoading(false);
                    myToast.notify_error("Failed to load report");
                  }}
                />
                </div>
                
                <style>{`
                  @keyframes shimmer {
                    0% {
                      transform: translateX(-100%);
                    }
                    100% {
                      transform: translateX(400%);
                    }
                  }
                  
                  @keyframes spin {
                    0% {
                      transform: rotate(0deg);
                    }
                    100% {
                      transform: rotate(360deg);
                    }
                  }
                  
                  @keyframes bounce {
                    0%, 80%, 100% {
                      transform: scale(0.8);
                      opacity: 0.5;
                    }
                    40% {
                      transform: scale(1.2);
                      opacity: 1;
                    }
                  }
                `}</style>
              </div>
            )}
          </>
        </div>
      </div>
    );
};

export default CollectionReport;

